// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Main__page___G1Pi4 {
    overflow: inherit;
    flex: 1;
    justify-content: center;
}

.Main__container___CNSJ9 {
    width: 100%;
    padding-right: 2rem;
    padding-bottom: 3.5rem;
    padding-left: 2rem;
}

.Main__page___G1Pi4 .Main__container___CNSJ9 {
    max-width: 120rem;
}

.Main__errorLoading___XSAK5 {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Main/Main.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,OAAO;IACP,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;AAC3B","sourcesContent":[".page {\n    overflow: inherit;\n    flex: 1;\n    justify-content: center;\n}\n\n.container {\n    width: 100%;\n    padding-right: 2rem;\n    padding-bottom: 3.5rem;\n    padding-left: 2rem;\n}\n\n.page .container {\n    max-width: 120rem;\n}\n\n.errorLoading {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `Main__page___G1Pi4`,
	"container": `Main__container___CNSJ9`,
	"errorLoading": `Main__errorLoading___XSAK5`
};
export default ___CSS_LOADER_EXPORT___;
